import { withIcon } from "../Icon"

export const IconSort = withIcon(
  '<rect width="16" height="1.5" x="4" y="8" fill="currentColor" rx=".75"/><rect width="16" height="1.5" x="4" y="16" fill="currentColor" rx=".75"/><circle cx="13.5" cy="8.5" r="1.75" fill="#fff" stroke="currentColor" stroke-width="1.5"/><circle cx="8.5" cy="16.5" r="1.75" fill="#fff" stroke="currentColor" stroke-width="1.5"/>',
)
